module.exports = __webpack_public_path__ + "static/media/error.2f4af876.svg";